import SwiperCore, { A11y, Navigation, Pagination, Virtual } from 'swiper'

// let initialized = false

export const initSwiper = (): void => {
  // if (initialized) return

  // initialized = true

  // install Swiper modules
  // eslint-disable-next-line react-hooks/rules-of-hooks
  SwiperCore.use([Navigation, Pagination, A11y, Virtual])
}
